import React from 'react'

const Header = ({ reportType, sort, sortOrder, onSortChange, groupBy }) => {
    return (
        <thead>
            <tr className="revenue-list revenue-list--header">
                {/*<th style={{ width: '100px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('creation')}>
                    Date&#160;
                    {sort === 'creation' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                </th>*/}

                {groupBy === false &&(
                    <th style={{ width: '100px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('audience_id')}>
                        Audience ID&#160;
                        {sort === 'audience_id' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                )}

                <th style={{ width: '100px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('marketplace')}>
                    Marketplace&#160;
                    {sort === 'marketplace' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                </th>
                <th style={{ width: '100px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('buyer_id')}>
                    Buyer&#160;
                    {sort === 'buyer_id' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                </th>
                <th style={{ width: '200px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('advertiser_id')}>
                    Advertiser&#160;
                    {sort === 'advertiser_id' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                </th>
                {/*<th style={{ width: '200px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('market_list_name')}>
                    Audience Name&#160;
                    {sort === 'market_list_name' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                </th>*/}
                <th className="revenue-list revenue-list--revenue pointer" onClick={() => onSortChange('impressions')}>
                    Impressions&#160;
                    {sort === 'impressions' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                </th>
                {/* 
                <th className="revenue-list revenue-list--revenue pointer" onClick={() => onSortChange('revenue')}>
                    Revenue&#160;
                    {sort === 'revenue' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                </th>
                */}
                
            </tr>
        </thead>
    )
}


export default Header
